import React from "react";
import Div from "../../../widget/common/ui/Div";
import { Col, Row } from "react-bootstrap";
import {
  ARFDateField,
  ARFMessageField,
  ARFNameField,
  ARFNoPeopleField,
  ARFSubjectField,
  ARFTimeField,
} from "./widget/ARFTextfields";
import { TextBlock } from "../../../widget/common/ui/Text";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { ARFContextImport } from "../../../provider/chats/chats/ARF/ARFContextProvider";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { ModalTitle } from "../../../widget/common/ui/Modals";
import UtilityHelper from "../../../service/utilities/UtilityHelper";

const ARFContent = () => {
  const type: number = ResponsiveDeviceType();

  const { formType } = ARFContextImport();

  return (
    <Div className="px-2 px-lg-0">
      {type !== 3 && (
        <ModalTitle>
          {formType === "2"
            ? AppTranslation.text("appointment_request")
            : formType === "3"
            ? AppTranslation.text("reservation_request")
            : UtilityHelper.ARFLabel(formType)}
        </ModalTitle>
      )}

      <Row className="pt-3">
        {formType !== "1" && (
          <Col xs={12} md={6}>
            <ARFNameField />
          </Col>
        )}

        <Col xs={12} md={6}>
          <ARFDateField />
        </Col>
        <Col xs={12} md={6}>
          <ARFTimeField />
        </Col>

        {formType === "3" ? (
          <Col xs={12} md={6}>
            <ARFNoPeopleField />
          </Col>
        ) : formType === "1" ? (
          <Col xs={12} md={6}>
            <ARFSubjectField />
          </Col>
        ) : (
          <></>
        )}
      </Row>

      <TextBlock fontName="book" fontSize="13_14" textColor="theme-sublabel">
        {AppTranslation.text(formType === "1" ? "message" : "special_request")}
      </TextBlock>
      <ARFMessageField />
    </Div>
  );
};

export default ARFContent;
